import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { OEComponents } from '@opportunityeducation/oe-web-common'

import AssignmentAvatars from '../../mini/AssignmentAvatars'

import { userCanViewAssignmentMessage } from '../../../utils/assignment'
import { assigned, returned, you } from '../../../utils/messages'
import { getUserDisplayName } from '../../../utils/name'

export default class Assignment extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageExpanded: false
    }
    this.toggleExpandMessageClickBound =
      this.toggleExpandMessageClick.bind(this)
  }

  render() {
    const {
      quest,
      isQuestAuthor,
      questIsAssignedToUser,
      questIsAssignedByUser,
      user,
      organization
    } = this.props
    const assignedReturned =
      isQuestAuthor && questIsAssignedToUser ? returned : assigned
    const messageClass = this.state.messageExpanded ? 'expanded' : 'collapsed'

    const intlAssignedMessage = (
      <FormattedMessage
        id={'Assignment.AssignedReturned'}
        defaultMessage={'{user1} {assignedReturned} {user2}.'}
        values={{
          user1: questIsAssignedByUser
            ? you
            : getUserDisplayName(quest.assigned_by),
          assignedReturned: assignedReturned,
          user2: questIsAssignedToUser
            ? you
            : getUserDisplayName(quest.assigned_to)
        }}
      />
    )

    return (
      <div className="assignment">
        <AssignmentAvatars
          fromPhotoUrl={quest.assigned_by.photo_url}
          toPhotoUrl={quest.assigned_to.photo_url}
        />
        <div className="assigned-returned">{intlAssignedMessage}</div>
        <OEComponents.ElapsedTimeFormatter
          cssClass="assigned-time"
          time={quest.assignment_updated_at}
        />
        {quest.assignment_message &&
          userCanViewAssignmentMessage(user, quest, organization) && (
            <div className={`assignment-message-container ${messageClass}`}>
              <div className="assignment-message">
                {quest.assignment_message}
              </div>
              {quest.assignment_message &&
                quest.assignment_message.length > 67 && (
                  <div
                    className="carat"
                    onClick={this.toggleExpandMessageClickBound}
                  />
                )}
            </div>
          )}
        <div className="line" />
      </div>
    )
  }

  toggleExpandMessageClick() {
    this.setState(state => ({ messageExpanded: !this.state.messageExpanded }))
  }
}

Assignment.propTypes = {
  quest: PropTypes.object.isRequired,
  isQuestAuthor: PropTypes.bool.isRequired,
  questIsAssignedToUser: PropTypes.bool.isRequired,
  questIsAssignedByUser: PropTypes.bool.isRequired,
  user: PropTypes.object.isRequired,
  organization: PropTypes.object.isRequired
}



// WEBPACK FOOTER //
// ./src/components/quest/assignment/Assignment.js